import { Position, PowerUpType, PowerUpVariant } from './game.interface';

// ===== SOCKET EVENT DATA INTERFACES =====
// These are used by both client and server for socket communication

export interface PlayerData {
  id: string;
  name: string;
  isReady: boolean;
  isHost: boolean;
  joinedAt: number;
}

/** Payload of `GameServerEvents.ATTACK_INCOMING`. */
export interface AttackData {
  attackerId: string;
  /** Explicit target; undefined when the attacker's default target was used. */
  targetPlayerId?: string;
  /** Grid cell where the warning block was placed on the target's board. */
  position: Position;
}

/** Payload of `GameServerEvents.POWER_UP_USED`. */
export interface PowerUpData {
  playerId: string;
  /** Explicit target of an opponent-variant power-up, as sent by the user. */
  targetPlayerId?: string;
  type: PowerUpType;
  variant: PowerUpVariant;
}

export interface GameData {
  gameId: string;
  timestamp: number;
  winner?: string;
  finalScores?: Record<string, number>;
}

export interface MatchEndResult {
  roomId: string;
  /** null when scores are exactly tied */
  winnerId: string | null;
  /** The player ID who held the Longest Snake title at match end, or null. */
  longestSnakeHolder: string | null;
  /** Effective scores (base + Longest Snake bonus for title holder). */
  scores: Record<string, number>;
  maxLengths: Record<string, number>;
  foodCounts: Record<string, number>;
  racingFoodWins: Record<string, number>;
  deathCounts: Record<string, number>;
  /** Players who were removed mid-game due to disconnect (shown as losers). */
  disconnectedPlayerIds?: string[];
  /** True when this match was decided by sudden death (winner broke the tie). */
  suddenDeath?: boolean;
}

export interface RoomData {
  id: string;
  playerCount: number;
  maxPlayers: number;
  isPrivate: boolean;
  createdAt: number;
  players: PlayerData[];
}
